let getSettings = () =>{
    return {
        api:"https://digikart7.herokuapp.com" ,       
    }
}


export default getSettings()